import {
  BasicMarksPlugin,
  BoldPlugin,
  ItalicPlugin,
  StrikethroughPlugin,
  UnderlinePlugin,
} from '@platejs/basic-nodes/react';
import { useEditorState } from 'platejs/react';

import BoldIcon from '../../../../../icons/bold.svg?react';
import ItalicIcon from '../../../../../icons/italic.svg?react';
import StrikethroughIcon from '../../../../../icons/strikethrough.svg?react';
import UnderlineIcon from '../../../../../icons/underline.svg?react';
import { ToolbarMarkButton } from '../../ToolbarMarkButton';

export const basicMarksPlugin = BasicMarksPlugin;

export const BasicMarksToolbarButtons = ({
  boldLabel = 'Bold',
  italicLabel = 'Italic',
  underlineLabel = 'Underline',
}: {
  boldLabel?: string;
  italicLabel?: string;
  underlineLabel?: string;
}) => {
  const editor = useEditorState();

  return (
    <>
      <ToolbarMarkButton
        icon={BoldIcon}
        label={boldLabel}
        type={editor.getType(BoldPlugin.key)}
      />
      <ToolbarMarkButton
        icon={UnderlineIcon}
        label={underlineLabel}
        type={editor.getType(UnderlinePlugin.key)}
      />
      <ToolbarMarkButton
        icon={ItalicIcon}
        label={italicLabel}
        type={editor.getType(ItalicPlugin.key)}
      />
    </>
  );
};

export const StrikethroughToolbarButtons = ({
  label = 'Strikethrough',
}: {
  label?: string;
}) => {
  const editor = useEditorState();

  return (
    <ToolbarMarkButton
      icon={StrikethroughIcon}
      label={label}
      type={editor.getType(StrikethroughPlugin.key)}
    />
  );
};
